export const ADDITIONAL_TRAINING_ROLES_LABEL = "Additional Training Roles";

export const ADDITIONAL_TRAINING_ROLES_TOOLTIP =
  "Assign extra organisation roles for QMS training only. SOPs, controlled documents, reading lists, and quizzes mapped to these roles will appear in this user's My Learnings and training compliance, in addition to content for their primary role. Does not change login role, permissions, or system access.";
